import React, { useEffect, useState } from "react";
import MainService from "../../helper/mainService";
import ApiService from "../../helper/api";
import Header from "../../componets/Header";
import { Link } from "react-router-dom";
import { GiWallet } from "react-icons/gi";
import {
	Container,
	Row,
	Col,
	Badge,
	Button,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import { FaCoins } from "react-icons/fa";
import AlertService from "../../helper/alertService";

const getIcon = platformName => {
	switch (platformName.toLowerCase()) {
		case "ethereum":
			return <FaCoins size={30} />;
		case "solana":
			return <FaCoins size={30} />;
		case "stellar":
			return <FaCoins size={30} />;
		case "tron":
			return <FaCoins size={30} />;
		default:
			return <FaCoins size={30} />;
	}
};

function SystemWallets(props) {
	const [data, setData] = useState([]);

	useEffect(() => {
		getSystemWallets();
	}, []);

	const getSystemWallets = () => {
		MainService.callApi({
			api: ApiService.getSystemWallets,
			cb: response => {
				if (response && response.data && response.data.length) {
					setData(response.data);
				}
			},
		});
	};

	const getWolletInfo = walletId => {
		if (!walletId) return false;
		MainService.callApi({
			api: ApiService.walletGetWalletBalance,
			data: walletId,
			cb: response => {
				if (response.data) {
					setData(
						data.map(el =>
							el.id === walletId
								? { ...el, walletInfo: { ...response.data, show: true } }
								: el,
						),
					);
				} else {
					AlertService.alert("error", "No Information");
					return null;
				}
			},
		});
	};

	const copyToClipboard = async text => {
		if (!navigator.clipboard) {
			AlertService.alert("error", "Copying is not supported in this browser");
			return false;
		}

		try {
			await navigator.clipboard.writeText(text);
			AlertService.alert("success", "Address copied to clipboard ✅");
			return true;
		} catch (err) {
			AlertService.alert("error", "Failed to copy text ❌");
			return false;
		}
	};

	const shortText = text =>
		text.length > 20 ? `${text.slice(0, 10)}...${text.slice(-6)}` : text;

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<GiWallet size={20} />
						</Link>
						<h4 className="mb-0">System wallets</h4>
					</div>
				</div>
			</Header>
			<Container style={{ paddingBlockEnd: "40px" }}>
				<Row className="g-4">
					{data.map(wallet => (
						<Col md={12} lg={6} key={wallet.id}>
							<div className="premium-card p-4 h-100">
								<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
									<h5 className="mb-0">{wallet.platformName}</h5>
									{getIcon(wallet.platformName)}
								</div>
								<OverlayTrigger
									placement={"bottom"}
									overlay={
										<Tooltip id={`tooltip-wallet-address`}>
											<span>
												<small>Copy</small>
											</span>
										</Tooltip>
									}>
									<p
										className="mb-2 cursor-pointer hover-shadow d-inline"
										// title="Copy"
										onClick={() => copyToClipboard(wallet.address)}>
										<strong>Address:</strong> <br /> {shortText(wallet.address)}
									</p>
								</OverlayTrigger>

								<p className="mb-3">
									<strong>Public Key:</strong> <br />{" "}
									{shortText(wallet.publicKey)}
								</p>

								{!!wallet?.walletInfo?.chains.length &&
									wallet?.walletInfo?.chains.map((chain, i) => (
										<React.Fragment key={i}>
											<hr className="bg-light" />

											<div className="mb-3">
												<div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
													<div className="d-flex align-items-center mb-1 contract-item gap-2">
														<img
															src={chain.chainLogo}
															alt={chain.currencySlug}
															width={30}
														/>
														<h5 className="mb-0">{chain.chainName}</h5>
													</div>
													<Badge bg="info">
														<div className="d-flex align-items-center gap-1">
															<span>{chain.chainBalance.toFixed(6)}</span>
															{chain.currencyLogo && (
																<img
																	src={chain.currencyLogo}
																	alt={chain.currencySlug}
																	width={16}
																	// className="me-2"
																/>
															)}
															(<span>{chain.currencySlug}</span>)
														</div>
													</Badge>
												</div>

												{chain.contracts.map((c, j) => (
													<div
														key={j}
														className="d-flex align-items-center mb-1 contract-item">
														<img
															src={c.logo}
															alt={c.name}
															width={24}
															className="me-2"
														/>
														<div>
															<div>
																{c.name} ({c.slug})
															</div>

															<small className="text-muted d-block">
																Balance: {c.contractBalance}
															</small>
															<OverlayTrigger
																placement={"bottom"}
																overlay={
																	<Tooltip
																		id={`tooltip-wallet-contractAddress`}>
																		<span>
																			<small>Copy</small>
																		</span>
																	</Tooltip>
																}>
																<small
																	className="ms-2 cursor-pointer "
																	title="Copy"
																	onClick={() =>
																		copyToClipboard(c.contractAddress)
																	}>
																	{shortText(c.contractAddress)}
																</small>
															</OverlayTrigger>
														</div>
													</div>
												))}
											</div>
										</React.Fragment>
									))}
								<Button
									className="copy-btn"
									onClick={() => getWolletInfo(wallet.id)}>
									{!!wallet?.walletInfo?.chains.length
										? "Update"
										: "Show more info"}
								</Button>
							</div>
						</Col>
					))}

					{/* {data.map(wallet => (
						<Col md={6} lg={4} key={wallet.id} className="mb-4">
							<Card className="shadow-sm border-0 h-100">
								<Card.Body>
									<div className="d-flex justify-content-between align-items-center mb-3">
										<h5 className="mb-0">{wallet.platformName}</h5>
										<Badge bg="primary">Type {wallet.platformType}</Badge>
									</div>

									<p className="mb-2">
										<strong>Address:</strong>
										<br />
										{shortText(wallet.address)}
									</p>

									<p className="mb-3">
										<strong>Public Key:</strong>
										<br />
										{shortText(wallet.publicKey)}
									</p>

									<Button
										variant="outline-primary"
										size="sm"
										onClick={() => copyToClipboard(wallet.address)}>
										Copy Address
									</Button>
								</Card.Body>
							</Card>
						</Col>
					))} */}
				</Row>
			</Container>
		</div>
	);
}

export default SystemWallets;
